/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * HTTP method for callback
 */
export type GetScheduledBotResponseInputDataCallbackConfigAnyOfMethod =
  (typeof GetScheduledBotResponseInputDataCallbackConfigAnyOfMethod)[keyof typeof GetScheduledBotResponseInputDataCallbackConfigAnyOfMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetScheduledBotResponseInputDataCallbackConfigAnyOfMethod = {
  POST: "POST",
  PUT: "PUT"
} as const
